import memberReducer from "./memberReducer";

const memberReducers = {
    member: memberReducer
};

export default memberReducers;